<template>
  <section class="edit-business">
    <h2>Edit Business Request</h2>
    <div class="abs-top-right">
      <v-button @click="$emit('cancel')">Cancel</v-button>
      <v-button
        type="primary"
        @click="handlerSave">Save</v-button>
    </div>

    <div class="form-item form-half">
      <span>Category</span>
      <!-- <v-radio-group
        v-model="type"
        :button="true"
        :list="ticketOptions.insureTypeOptions" /> -->
      <div class="form-half">
        <v-select
          v-model="type"
          :group="true"
          :list="typeOptions"  />
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="formRule"
    >
      <div
        class="form-container"
        :class="{
          'is-industry': isIndustry
        }">
        <div class="form-left-container">
          <section v-if="type !== ''">
            <div class="form-item">
              <!-- <span>Contact Person Name</span> -->
              <el-form-item
                ref="name"
                prop="name"
                label="Contact Person Name">
                <v-input v-model="formData.name" />
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Contact Number</span>-->
              <el-form-item
                ref="phone"
                prop="phone"
                label="Contact Number">
                <v-input
                  v-model="formData.phone"
                  type="number"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Email</span>-->
              <el-form-item
                ref="email"
                prop="email"
                label="Email">
                <v-input v-model="formData.email" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Referral Code</span>
              <v-input v-model="formData.promo_code" />
            </div>
            <div class="form-item">
              <span>Coupon Code</span>
              <el-form-item prop="coupon_code">
                <v-input
                  v-model="formData.coupon_code"
                  maxlength="20"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Renewal Notice</span>
              <section v-show="formData.renewal_notice && formData.renewal_notice.id">
                <file-container
                  :fileData="formData.renewal_notice"
                  :edit="true"
                  titleName= "Renewal Notice"
                  @uploadSuccess="handlerUploadRenewalNoticeSuccess"
                  @delete="deleteRenewalNoticeFile" />
              </section>
              <v-upload
                @uploadSuccess="handlerUploadRenewalNoticeSuccess" />
            </div>
          </section>
          <section v-if="type === 2001">
            <div class="form-item">
              <span>Type of Restaurant</span>
              <v-select
                v-model="formData.restaurant_id"
                :list="globalOptions.typ_of_restaurant" />
            </div>
          </section>
          <section v-if="type === 1500">
            <div class="form-item">
              <span>Type of Insurance</span>
              <v-radio-group
                v-model="motorsType"
                :button="true"
                :list="ticketOptions.motorsTypeOptions" />
            </div>
            <section v-if="motorsType === 1502">
              <div class="form-item">
                <!--                <span>Name of insured</span>-->
                <el-form-item
                  ref="isrd_nm"
                  prop="isrd_nm"
                  label="Name of insured">
                  <v-input v-model="formData.isrd_nm" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Bussiness / Occupation </span>
                <v-select
                  v-model="formData.isrd_bo"
                  :list="globalOptions.industry" />
              </div>
              <div class="form-item">
                <span>Number of driver(s)</span>
                <v-radio-group
                  v-model="formData.no_of_nm_drvr"
                  :border="true"
                  :list="numberFourOptions" />
              </div>
            </section>
          </section>
        </div>

        <!-- right -->
        <div class="form-right-container">
          <industry-form
            v-if="isIndustry"
            ref="industry-form"
            :form="formData"
            :type="type"
            @getFormData="getIndustryForm" />


          <!-- Motors Fleet / Motor Trade -->
          <section v-if="type === 1500">
            <section v-if="motorsType === 1501">
              <div class="form-item">
                <!--                <span>Name of insured</span>-->
                <el-form-item
                  ref="isrd_nm"
                  prop="isrd_nm"
                  label="Name of insured">
                  <v-input v-model="formData.isrd_nm" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Bussiness Nature </span>
                <v-select
                  v-model="formData.isrd_bo"
                  :list="globalOptions.industry" />
              </div>
              <div class="form-item">
                <span>Vehicle Type </span>
                <v-select
                  v-model="formData.vehicle_type"
                  :list="globalOptions.vehicle_type"/>
              </div>
            </section>
            <section v-if="motorsType === 1502">
              <el-tabs>
                <el-tab-pane
                  v-for="(item, index) in formData.no_of_nm_drvr"
                  :key="index"
                  :label="'Driver ' + (index+1)"
                  :name="String(index)">
                  <div class="form-item">
                    <span>Name</span>
                    <v-input v-model="formData.nm_drvr_list[index].nm_drvr_name" />
                  </div>
                  <div class="form-item">
                    <span>Age</span>
                    <v-select
                      v-model="formData.nm_drvr_list[index].nm_drvr_age"
                      :list="globalOptions.motor_trade_age" />
                  </div>
                  <div class="form-item">
                    <span>Years of driving experience</span>
                    <v-radio-group
                      v-model="formData.nm_drvr_list[index].nm_drvr_exp"
                      :border="true"
                      :list="globalOptions.motor_trade_drvr_exp" />
                  </div>
                  <div class="form-item">
                    <span>Relationship to the Insured </span>
                    <v-select
                      v-model="formData.nm_drvr_list[index].nm_drvr_rel_id"
                      :list="globalOptions.relationship_insured" />
                  </div>
                  <div class="form-item">
                    <span>Have been prosecuted or been deducted more than five driving offence points in total or had driving license disqualified by a court in the last two years?</span>
                    <v-radio-group
                      v-model="formData.nm_drvr_list[index].nm_drvr_ded_ind"
                      :border="true"
                      :list="yesNo2Options" />
                  </div>
                  <div class="form-item">
                    <span>Have suffered/been suffering from heart diseases, diabetes and epilepsy; defective vision or hearing; or physical and mental infirmities?</span>
                    <v-radio-group
                      v-model="formData.nm_drvr_list[index].nm_drvr_ill_ind"
                      :border="true"
                      :list="yesNo2Options" />
                  </div>
                  <div class="form-item">
                    <span>Have had any motor insurance refused? </span>
                    <v-radio-group
                      v-model="formData.nm_drvr_list[index].nm_drvr_refus_ind"
                      :border="true"
                      :list="yesNo2Options" />
                  </div>
                  <div class="form-item">
                    <span>Have had any accidents, losses or claims in the past three years or are under any police enquiries and prosecutions?</span>
                    <v-radio-group
                      v-model="formData.nm_drvr_list[index].nm_drvr_accid_ind"
                      :border="true"
                      :list="yesNo2Options" />
                  </div>
                  <div class="form-item">
                    <span>Have made any motor claims against other insurance companies in the past three years?</span>
                    <v-radio-group
                      v-model="formData.nm_drvr_list[index].nm_drvr_claim_ind"
                      :border="true"
                      :list="yesNo2Options" />
                  </div>
                </el-tab-pane>
              </el-tabs>
              <div class="form-item">
                <span>Latest insurance company (if any)</span>
                <v-select
                  v-model="formData.last_insured_ind"
                  :list="globalOptions.latest_insurance_company" />
              </div>
              <div class="form-item">
                <span>Policy number (if known) </span>
                <v-input v-model="formData.pcy_no" />
              </div>
            </section>
          </section>
          <!-- Business Package -->
          <section v-if="type === 1001">
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Name of insured">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Effective Date </span>
              <v-date-picker v-model="formData.eff_dt" />
            </div>
            <div class="form-item">
              <span>Bussiness Nature </span>
              <v-select
                v-model="formData.business"
                :list="globalOptions.industry" />
            </div>
            <div class="form-item">
              <!--              <span>Sum Insured - Building </span>-->
              <el-form-item
                ref="sum_building"
                prop="sum_building"
                label="Sum Insured - Building ">
                <v-input
                  v-model="formData.sum_building"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Sum Insured - Contents </span>-->
              <el-form-item
                ref="sum_content"
                prop="sum_content"
                label="Sum Insured - Contents ">
                <v-input
                  v-model="formData.sum_content"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Sum Insured - Stock</span>-->
              <el-form-item
                ref="sum_stock"
                prop="sum_stock"
                label="Sum Insured - Stock ">
                <v-input
                  v-model="formData.sum_stock"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>No. of Employee(s)</span>-->
              <el-form-item
                ref="no_of_employee"
                prop="no_of_employee"
                label="No. of Employee(s) ">
                <v-input
                  v-model="formData.no_of_employee"
                  append="Person"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Have you made or reported claim in the last 3 years?</span>
              <!-- <v-input v-model="formData.claim_ind" /> -->
              <v-radio-group
                v-model="formData.claim_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <div class="form-item">
              <span>Do you have any existing policy schedule(s)?</span>
              <v-radio-group
                v-model="formData.pcy_sch_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <span class="address-label">Insured Premises Address</span>
            <address-form
              ref="address-form"
              :formDataLock="formDataLock"
              :form="formData"
              :formType="1"
              :addrNoRequire='true'
              @getFormData="getSubFormData" />
          </section>
          <!-- Employee Compensation (E.C.) -->
          <section v-if="type === 1101">
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Insured Name">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Effective Date </span>
              <v-date-picker v-model="formData.eff_dt" />
            </div>
            <div class="form-item">
              <span>Bussiness Nature </span>
              <v-select
                v-model="formData.business"
                :list="globalOptions.industry" />
            </div>
            <div class="form-item">
              <!--              <span>No. of Employee(s)</span>-->
              <el-form-item
                ref="no_of_employee"
                prop="no_of_employee"
                label="No. of Employee(s)">
                <v-input v-model="formData.no_of_employee"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Work oversea?</span>
              <v-radio-group
                v-model="formData.oversea_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <div class="form-item">
              <span>Do you have any existing policy schedule(s)?</span>
              <v-radio-group
                v-model="formData.pcy_sch_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <span class="address-label">Insured Premises Address</span>
            <address-form
              ref="address-form"
              :formDataLock="formDataLock"
              :form="formData"
              :formType="1"
              @getFormData="getSubFormData" />
          </section>
          <!-- Contractors’ All Risks (C.A.R.) -->
          <section v-if="type === 1601">
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Insured Name">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Contract Period</span>
              <v-select
                v-model="formData.contract_period"
                :list="globalOptions.contract_period" />
            </div>
            <div class="form-item">
              <!--              <span>Total Contract Value</span>-->
              <el-form-item
                ref="total_contract_vl"
                prop="total_contract_vl"
                label="Total Contract Value">
                <v-input
                  v-model="formData.total_contract_vl"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Material Damage</span>
              <v-radio-group
                v-model="formData.material_damage_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <div class="form-item">
              <span>Third Party Liability</span>
              <v-select
                v-model="formData.third_party_liability"
                :list="globalOptions.third_party_liability" />
            </div>
            <div class="form-item">
              <span>Scaffolding Work</span>
              <v-radio-group
                v-model="formData.scaffold_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <div class="form-item">
              <!--              <span>Contract Value</span>-->
              <el-form-item
                ref="contract_vl"
                prop="contract_vl"
                label="Contract Value">
                <v-input
                  v-model="formData.contract_vl"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Work at Height</span>
              <v-select
                v-model="formData.work_at_height"
                :list="globalOptions.work_at_height" />
            <!-- <v-input
              v-model="formData.work_at_height_other"
              placeholder="Other Value"
              :disabled="disabledOtherWorkAtHeight"
              class="mg-t-10" /> -->
            </div>
            <div class="form-item">
              <span>Outdoor Work</span>
              <v-radio-group
                v-model="formData.outdoor_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <div
              v-if="formData.outdoor_ind == 1"
              class="form-item">
              <!--              <span>Contract Sum of Out Door Work</span>-->
              <el-form-item
                ref="outdoor_vl"
                prop="outdoor_vl"
                label="Contract Sum of Out Door Work">
                <v-input
                  v-model="formData.outdoor_vl"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Employees' Compensation</span>
              <v-radio-group
                v-model="formData.compensation_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <div class="form-item">
              <span>Please provide Scope of Work & Contract Breakdown</span>
              <section v-if="formData.photos && formData.photos.id">
                <file-container
                  :fileData="formData.photos"
                  :edit="true"
                  titleName= "Please provide Scope of Work & Contract Breakdown"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="deletePhotosFile" />
              </section>
              <v-upload
                @uploadSuccess="handlerUploadSuccess" />

            </div>

          </section>
          <!-- Employee Benefits (E.B.) -->
          <section v-if="type === 1200">
            <div class="form-item">
              <span>Type</span>
              <v-select
                v-model="benefitsType"
                :list="ticketOptions.benefitsTypeOptions" />
            </div>
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Insured Name">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Effective Date </span>
              <v-date-picker v-model="formData.eff_dt" />
            </div>
            <div class="form-item">
              <span>Bussiness Nature </span>
              <v-select
                v-model="formData.business"
                :list="globalOptions.industry" />
            </div>
            <div class="form-item">
              <!--              <span>No. of Employee(s)</span>-->
              <el-form-item
                ref="no_of_employee"
                prop="no_of_employee"
                label="No. of Employee(s)">
                <v-input
                  v-model="formData.no_of_employee"
                  append="Person"/>
              </el-form-item>
            </div>
            <section v-if="benefitsType === 1202">
              <div class="form-item">
                <span>Manual work involved?</span>
                <v-radio-group
                  v-model="formData.manual_ind"
                  :border="true"
                  :list="yesNo2Options" />
              </div>
              <div class="form-item">
                <span>Stationed overseas?</span>
                <v-radio-group
                  v-model="formData.oversea_ind"
                  :border="true"
                  :list="yesNo2Options" />
              </div>
            </section>
            <section v-if="benefitsType !== 1203">
              <div class="form-item">
                <span>Have you made or reported claim in the last 3 years?</span>
                <v-radio-group
                  v-model="formData.claim_ind"
                  :border="true"
                  :list="yesNo2Options" />
              </div>
            </section>
            <section v-if="benefitsType === 1203">
              <div class="form-item">
                <!--                <span>No. of Spouse(s)</span>-->
                <el-form-item
                  ref="no_of_spouse"
                  prop="no_of_spouse"
                  label="No. of Spouse(s)">
                  <v-input v-model="formData.no_of_spouse" />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--                <span>No. of Kid(s)</span>-->
                <el-form-item
                  prop="no_of_kid"
                  label="No. of Kid(s)">
                  <v-input v-model="formData.no_of_kid" />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--                <span>No. of Member(s) Over Age 64</span>-->
                <el-form-item
                  ref="no_of_older"
                  prop="no_of_older"
                  label="No. of Member(s) Over Age 64">
                  <v-input v-model="formData.no_of_older" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Have you made or reported a claim in the last 3 years (At least for the past 9 months)?</span>
                <v-radio-group
                  v-model="formData.claim_ind"
                  :border="true"
                  :list="yesNo2Options" />
              </div>
            </section>
            <div class="form-item">
              <span>Do you have any existing policy schedule(s)?</span>
              <v-radio-group
                v-model="formData.pcy_sch_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
          </section>

          <!-- Public Liability -->
          <section v-if="type === 1301">
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Insured Name">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Effective Date </span>
              <v-date-picker v-model="formData.eff_dt" />
            </div>
            <div class="form-item">
              <span>Bussiness Nature </span>
              <v-select
                v-model="formData.business"
                :list="globalOptions.industry" />
            </div>
            <div class="form-item">
              <span>Limit of Liability</span>
              <v-select
                v-model="formData.limit_of_liability"
                :list="globalOptions.limit_of_liability" />
            </div>
            <div class="form-item">
              <span>Have you made or reported claim in the last 3 years?</span>
              <v-radio-group
                v-model="formData.claim_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <div class="form-item">
              <span>Do you have any existing policy schedule(s)?</span>
              <v-radio-group
                v-model="formData.pcy_sch_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <span class="address-label">Insured Premises Address</span>
            <address-form
              ref="address-form"
              :formDataLock="formDataLock"
              :form="formData"
              :formType="1"
              @getFormData="getSubFormData" />
          </section>
          <!-- Property -->
          <section v-if="type === 1401">
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Insured Name">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Effective Date </span>
              <v-date-picker v-model="formData.eff_dt" />
            </div>
            <div class="form-item">
              <span>Bussiness Nature </span>
              <v-select
                v-model="formData.business"
                :list="globalOptions.industry" />
            </div>
            <div class="form-item">
              <!--              <span>Sum Insured - Building </span>-->
              <el-form-item
                ref="sum_building"
                prop="sum_building"
                label="Sum Insured - Building">
                <v-input
                  v-model="formData.sum_building"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Sum Insured - Contents </span>-->
              <el-form-item
                ref="sum_content"
                prop="sum_content"
                label="Sum Insured - Contents">
                <v-input
                  v-model="formData.sum_content"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Sum Insured - Stock</span>-->
              <el-form-item
                ref="sum_stock"
                prop="sum_stock"
                label="Sum Insured - Stock">
                <v-input
                  v-model="formData.sum_stock"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <!--              <span>Sum Insured - Machinery/Tools of Trade</span>-->
              <el-form-item
                ref="sum_mt"
                prop="sum_mt"
                label="Sum Insured - Machinery/Tools of Trade">
                <v-input
                  v-model="formData.sum_mt"
                  append="HK$"
                  type="number"
                  :min="0"
                  :int="true"
                  :keyNumber="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Have you made or reported claim in the last 3 years?</span>
              <v-radio-group
                v-model="formData.claim_ind"
                :border="true"
                :list="yesNo2Options" />
              <section
                v-if="formData.photos && formData.photos.id&&formData.claim_ind==1"
                class="upload-box" >
                <file-container
                  :fileData="formData.photos"
                  :edit="true"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="deletePhotosFile" />
              </section>
              <v-upload
                v-if="!formData.photos.id&&formData.claim_ind==1"
                class="upload-box"
                @uploadSuccess="handlerUploadSuccess" />
            <!--            <file-container-->
            <!--              :edit="true"-->
            <!--              :fileData="{-->
            <!--                url: formData.photos.id_type_pic_url,-->
            <!--                client_name: formData.photos.client_name-->
            <!--              }"-->
            <!--              :otherData="{-->
            <!--                idKey: 'id_type_pic_path_id',-->
            <!--                nameKey: 'id_type_pic_path',-->
            <!--                urlKey: 'id_type_pic_url',-->
            <!--                client_name:'client_name'-->
            <!--              }"-->
            <!--              @delete="handlerDeleteFile"-->
            <!--              @uploadSuccess="handlerUploadSuccess" />-->
            </div>
            <div class="form-item">
              <span>Do you have any existing policy schedule(s)?</span>
              <v-radio-group
                v-model="formData.pcy_sch_ind"
                :border="true"
                :list="yesNo2Options" />
            </div>
            <span class="address-label">Insured Premises Address</span>
            <address-form
              ref="address-form"
              :formDataLock="formDataLock"
              :form="formData"
              :formType="1"
              @getFormData="getSubFormData" />
          </section>
          <!-- Marine Cargo -->
          <section v-if="type === 1701">
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Insured Name">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Interest / Goods to be insured</span>
              <v-input v-model="formData.goods" />
            </div>
            <div class="form-item">
              <span>Packing</span>
              <v-input v-model="formData.packing" />
            </div>
            <div class="form-item">
              <span>From</span>
              <v-input v-model="formData.from" />
            </div>
            <div class="form-item">
              <span>To</span>
              <v-input v-model="formData.to" />
            </div>
            <div class="form-item">
              <span>Via</span>
              <v-input v-model="formData.via" />
            </div>
            <!-- <div class="form-item">
              <span>Voyage / Transit</span>
              <v-input v-model="formData.via" />
            </div> -->
            <div class="form-item">
              <span>Conveyance</span>
              <v-select
                v-model="formData.conveyance"
                :list="globalOptions.conveyance" />
            </div>
            <div class="flex-sb">
              <div class="form-item currency-width">
                <span>Currency</span>
                <v-select
                  v-model="formData.currency"
                  valueKey="name"
                  :list="globalOptions.currency" />
              </div>
              <div class="form-item flex-1">
                <span>Basis of Valuation (Invoice Value)</span>
                <v-input v-model="formData.valuation" />
              </div>
            </div>
            <div class="form-item">
              <span>Terms of cover required</span>
              <v-select
                v-model="formData.trm_of_cvr"
                :list="globalOptions.terms_of_cover_required" />
            </div>
            <div class="form-item">
              <span>Additional Conditions</span>
              <v-input
                v-model="formData.additional_conditions"
                :rows="4"
                type="textarea" />
            </div>
          </section>
          <!-- Other -->
          <section v-if="type === 9000">
            <div class="form-item">
              <!--              <span>Insured Name </span>-->
              <el-form-item
                ref="isrd_nm"
                prop="isrd_nm"
                label="Insured Name">
                <v-input v-model="formData.isrd_nm" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Insurance Type</span>
              <v-checkbox-group
                v-model="formData.other_insurance_type"
                :block="true"
                :list="ticketOptions.insuranceTypeOptions" />
            </div>
            <div class="form-item">
              <span>Message</span>
              <v-input
                v-model="formData.message"
                :rows="4"
                type="textarea" />
            </div>
          </section>
        </div>
      </div>
    </el-form>
    <div
      v-if="isDev"
      class="text-block">
      <v-button
        type="danger"
        @click="handlerTest">Auto Fill</v-button>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import AddressForm from '@/views/components/address-form'
import FileContainer from '@/views/components/file-container'
import {changeTicketCategory, editTicketBusiness} from '@/api/ticket'
import MixinRules from '@/mixins/rules'
import IndustryForm from '@/views/tickets/components/form/industry/industry-form'

export default {
  name: 'EditBusiness',
  components: {
    AddressForm,
    FileContainer,
    IndustryForm
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    ticketId: [Number, String],
    changeCategoryType: {
      type: [Number, String],
      default: ''
    },
    customerId: Number,
    form: {
      type: Object,
      default: () => ({})
    },
    isFina: {
      type: Boolean,
      default:false
    }
  },
  data() {
    const driverObj = {
      nm_drvr_name: '',
      nm_drvr_age: '',
      nm_drvr_exp: '',
      nm_drvr_occ_id: 0,
      nm_drvr_rel_id: '',
      nm_drvr_ded_ind: '',
      nm_drvr_ill_ind: '',
      nm_drvr_refus_ind: '',
      nm_drvr_accid_ind: '',
      nm_drvr_claim_ind: '',
    }
    return {
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      type: 9000,
      driverObj,
      motorsType: 1501,
      benefitsType: 1201,
      formData: {
        id: '',
        // assignee_id: '',
        // customer_id: '',
        insurance_type: '',
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        renewal_notice: {},
        renewal_notice_path_id: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        sum_building: '',
        sum_content: '',
        sum_stock: '',
        no_of_employee: '',
        claim_ind: '',
        pcy_sch_ind: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        no_of_nm_drvr: 1,
        nm_drvr_list: [
          {
            ...driverObj
          },
          {
            ...driverObj
          },
          {
            ...driverObj
          },
          {
            ...driverObj
          },
        ],
        oversea_ind: '',
        contract_period: '',
        total_contract_vl: '',
        third_party_liability: '',
        work_at_height: '',
        work_at_height_other: '',
        scaffold_ind: '',
        contract_vl: '',
        material_damage_ind: '',
        outdoor_ind: '',
        outdoor_vl: '',
        compensation_ind: '',
        photos: {
          id: '',
          thumb_name: '',
          url: '',
          thumb_url: '',
        },
        isrd_bo: '',
        vehicle_type: '',
        last_insured_ind: '',
        pcy_no: '',
        manual_ind: '',
        no_of_spouse: '',
        no_of_kid: '',
        no_of_older: '',
        limit_of_liability: '',
        sum_mt: '',
        goods: '',
        packing: '',
        from: '',
        to: '',
        via: '',
        conveyance: '',
        valuation: '',
        trm_of_cvr: '',
        other_insurance_type: [],
        message: '',
        additional_conditions: '',
        currency: ''
      },
      businessPackageForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        sum_building: '',
        sum_content: '',
        sum_stock: '',
        no_of_employee: '',
        claim_ind: '',
        pcy_sch_ind: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      employeeCompensationForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        no_of_employee: '',
        claim_ind: '',
        pcy_sch_ind: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        //
        oversea_ind: ''
      },
      constractorAllRisksForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        isrd_nm: '',
        //
        contract_period: '',
        total_contract_vl: '',
        third_party_liability: '',
        work_at_height: '',
        work_at_height_other: '',
        scaffold_ind: '',
        contract_vl: '',
        material_damage_ind: '',
        outdoor_ind: '',
        outdoor_vl: '',
        compensation_ind: '',
        photos: {
          id: '',
          name: '',
          thumb_name: '',
          url: '',
          thumb_url: ''
        },
      },
      motorsFleetForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        isrd_nm: '',
        isrd_bo: '',
        vehicle_type: ''
      },
      motorTradeForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        isrd_bo: '',
        no_of_nm_drvr: '',
        nm_drvr_list: [],
        last_insured_ind: '',
        pcy_no: '',
        isrd_nm:''
      },
      employeeBenefitsTravelForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        no_of_employee: '',
        claim_ind: '',
        pcy_sch_ind: ''
      },
      employeeBenefitsAccidentForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        no_of_employee: '',
        claim_ind: '',
        pcy_sch_ind: '',
        //
        manual_ind: '',
        oversea_ind: ''
      },
      employeeBenefitsMedicalForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        no_of_employee: '',
        claim_ind: '',
        pcy_sch_ind: '',
        //
        no_of_spouse: '',
        no_of_kid: '',
        no_of_older: ''
      },
      publicLiabilityForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        limit_of_liability: '',
        claim_ind: '',
        pcy_sch_ind: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      propertyForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        isrd_nm: '',
        eff_dt: '',
        business: '',
        sum_building: '',
        sum_content: '',
        sum_stock: '',
        sum_mt: '',
        claim_ind: '',
        pcy_sch_ind: '',
        photos: {},
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      MarineCargoForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        isrd_nm: '',
        goods: '',
        packing: '',
        from: '',
        to: '',
        via: '',
        conveyance: '',
        valuation: '',
        trm_of_cvr: '',
        additional_conditions: '',
        currency: ''
      },
      othersForm: {
        name: '',
        email: '',
        phone: '',
        promo_code: '',
        coupon_code: '',
        isrd_nm: '',
        other_insurance_type: [],
        message: ''
      },
      subForm: {
        'address-form': false
      },
      otherInsuranceType:[],
      extraRules: {
        // email: [
        //   { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
        //   { validator: checkEmail, trigger: ['blur'] }
        // ],
      }
    }
  },
  computed: {
    formRule(){
      let rule = this.rules
      Object.keys(rule).some(item=>{
        if(item==='coupon_code')
        {
          rule[item][0].required = false
        }
      })
      return rule
    },
    disabledOtherWorkAtHeight() {
      return this.formData.work_at_height !== 99
    },
    typeOptions() {
      return [
        {
          label: 'By Insurance Type',
          options: this.ticketOptions.insureTypeOptions
        },
        {
          label: 'By Industry',
          options: this.industryTypeOptions
        }
      ]
    },
    isIndustry() {
      return [
        2001, 2101, 2201, 2301, 2401, 2501, 2601, 2701
      ].includes(this.type)
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.formDataLock += 1
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
        // this.type = val.insurance_type
        // 處理 type
        this.handler().handlerType(val.insurance_type)
        let {other_insurance_type = []} = this.formData
        if(other_insurance_type.length<=0)
          this.formData.other_insurance_type = []

      }
    },
    'formData.coupon_code':{
      immediate: true,
      handler(val){
        if (val) {
          this.formData.coupon_code = this.formData.coupon_code.toLocaleUpperCase()
        }
      }
    }
  },
  methods: {
    handlerTest() {
      const params = {
        // assignee_id: 1,
        // customer_id: 91,
        insurance_type: 1001,
        name: 'APeng',
        email: 'example@gmail.com',
        phone: '67896789',
        promo_code: '5555',
        isrd_nm: 'APeng',
        eff_dt: '2020-06-01',
        business: 20,
        sum_building: '2000',
        sum_content: '200',
        sum_stock: '20',
        no_of_employee: 1,
        claim_ind: 1,
        pcy_sch_ind: 1,
        addr_room: '55',
        addr_floor: '55',
        addr_block: '55',
        addr_building: '55',
        addr_street: '55',
        addr_district: 5,
        addr_area: 2,
        addr_region: 1,
        no_of_nm_drvr: 1,
        nm_drvr_list: [
          {
            nm_drvr_name: 'APeng',
            nm_drvr_age: 1,
            nm_drvr_exp: '1',
            nm_drvr_occ_id: 1,
            nm_drvr_rel_id: 1,
            nm_drvr_ded_ind: 1,
            nm_drvr_ill_ind: 1,
            nm_drvr_refus_ind: 1,
            nm_drvr_accid_ind: 1,
            nm_drvr_claim_ind: 1,
          },
          {
            ...this.driverObj
          },
          {
            ...this.driverObj
          },
          {
            ...this.driverObj
          },
        ],
        oversea_ind: 1,
        contract_period: 1,
        total_contract_vl: '2000',
        third_party_liability: '2000',
        work_at_height: 1,
        work_at_height_other: '',
        scaffold_ind: 1,
        contract_vl: '2000',
        material_damage_ind: 1,
        outdoor_ind: 1,
        outdoor_vl: '200',
        compensation_ind: 1,
        photos: {
          id: '',
          thumb_name: '',
          url: '',
          thumb_url: '',
        },
        isrd_bo: 1,
        vehicle_type: 11,
        last_insured_ind: 1,
        pcy_no: 'ABC55555',
        manual_ind: 1,
        no_of_spouse: 1,
        no_of_kid: 1,
        no_of_older: 1,
        limit_of_liability: 5000000,
        sum_mt: '2000',
        goods: '222',
        packing: '2000',
        from: '',
        to: '',
        via: '2000',
        conveyance: 1,
        valuation: '200',
        trm_of_cvr: 1,
        other_insurance_type: [9001],
        message: 'Nothing'
      }
      this.type = 1001
      this.formDataLock += 1
      this.formData = Object.assign(this.formData, params)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      Object.assign(this.formData, data)
    },
    getIndustryForm(data) {
      const {
        name,
        phone,
        email,
        promo_code,
        coupon_code,
        renewal_notice,
        restaurant_id,
      } = this.formData
      const params = {
        name,
        phone,
        email,
        promo_code,
        coupon_code,
        restaurant_id,
        renewal_notice_path_id: renewal_notice && renewal_notice.id,
        insurance_type: this.type,
        ticket_id: this.ticketId,
        customer_id: this.customerId,
        ...data
      }
      this.network().editTicketBusiness(params)
    },
    deletePhotosFile() {
      this.formData.photos = {}
    },
    deleteRenewalNoticeFile() {
      this.formData.renewal_notice = {}
    },
    handlerUploadRenewalNoticeSuccess({ data }) {
      this.formData.renewal_notice = data
    },
    // // file-container 組件刪除文件
    // handlerDeleteFile(otherData) {
    //   const { type, index, idKey, nameKey, urlKey } = otherData
    //   if(type === 'other') {
    //     this.formData.other_file.splice(index, 1)
    //   }
    // },
    // handlerUploadSuccess({ data, result, otherData }) {
    //   const { type, idKey, nameKey,  urlKey, target } = otherData
    //   const { id, name, url,client_name } = data
    //
    //   this.$set(this.formData, idKey, id)
    //   this.$set(this.formData, urlKey, url)
    //   this.$set(this.formData, nameKey, name)
    //   this.$set(this.formData, 'client_name', client_name)
    //   this.$refs['form'].clearValidate([idKey])
    // },

    handlerUploadSuccess({ data }) {
      this.formData.photos = data
    },
    handlerSave() {
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          if(this.isIndustry) {
            this.$refs['industry-form'].submitForm()
            return
          }



          const type = Number(this.type)
          this.subForm['address-form'] = false
          this.formData.insurance_type = type
          const addressArray = [1001, 1101, 1301, 1401]
          if (addressArray.includes(type)) {
            const formName = {
              '1001': 'businessPackageForm',
              '1101': 'employeeCompensationForm',
              '1301': 'publicLiabilityForm',
              '1401': 'propertyForm'
            }
            this.$refs['address-form'].submitForm('address-form')
            if (this.subForm['address-form']) {
              this.handler().handlerParams(formName[type])
            }
          } else if ([1601, 1701, 9000].includes(type)) {
            const formName = {
              '1601': 'constractorAllRisksForm',
              '1701': 'MarineCargoForm',
              '9000': 'othersForm'
            }
            this.handler().handlerParams(formName[type])
          } else if (type === 1500) {
            this.formData.insurance_type = this.motorsType
            if (this.motorsType === 1501) {
              this.handler().handlerParams('motorsFleetForm')
            } else {
              this.handler().handlerParams('motorTradeForm')
            }
          } else if (type === 1200) {
            const benefitsType = this.benefitsType
            this.formData.insurance_type = benefitsType
            const benefitsForm = {
              '1201': 'employeeBenefitsTravelForm',
              '1202': 'employeeBenefitsAccidentForm',
              '1203': 'employeeBenefitsMedicalForm'
            }
            this.handler().handlerParams(benefitsForm[benefitsType])
          }
        }else{
          this.scrollToValidDom(rules)
          this.$message({
            type: 'warning',
            message: '請填寫需填的信息'
          })
        }
      })
    },
    handler() {
      return {
        handlerType: insuranceType => {
          const type = Number(insuranceType)
          // if([1401, 1001, 1301, 1101, 1601, 1701, 9000].includes(type)) {
          //   this.type = type
          // }
          if(type >= 1200 && type <= 1299) {
            this.type = 1200
            this.benefitsType = type
          }
          else if(type >= 1500 && type <= 1599) {
            this.type = 1500
            this.motorsType = type
          }
          else {
            this.type = type
          }
        },
        handlerParams: target => {
          const params = {
            ...this[target],
            // assignee_id: '',
            // customer_id: '',
            insurance_type: '',
            merchant_platform:this.isFina?2:1
          }
          Object.keys(params).forEach(key => {
            params[key] = this.formData[key]
          })

          // 後端要id
          params.renewal_notice_path_id =  this.formData.renewal_notice && this.formData.renewal_notice.id

          // 處理記名司機數據
          if(target === 'motorTradeForm') {
            let { no_of_nm_drvr, nm_drvr_list } = params
            let driverList = nm_drvr_list.slice(0, no_of_nm_drvr)
            params.nm_drvr_list = driverList
          }
          params.ticket_id = this.ticketId
          params.customer_id = this.customerId
          if(this.changeCategoryType === '') {
            this.network().editTicketBusiness(params)
          } else {
            this.network().changeTicketCategory(params)
          }

        }
      }
    },
    network() {
      return {
        changeTicketCategory: async params => {
          const { data } = await changeTicketCategory({
            // ticket_id: this.ticketId,
            type: 5,
            // customer_id: this.customerId,
            ...params
          })
          // 初始化表單
          this.$emit('save')
        },
        editTicketBusiness: async params => {
          const { data } = await editTicketBusiness({
            ...params,
            id: this.formData.id
          })
          this.$emit('save')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-business {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 20px;
        right: 15px;
    }
    .address-label {
      display: block;
      padding-top: 8px;
      padding-bottom: 16px;
      font-size: 16px;
      color: #616266;
      font-weight: 400;
    }
    .form-container {
       display: flex;
       &.is-industry {
         .form-right-container {
           flex: 1;
         }
       }
       .form-left-container {
         margin-right: 20px;
         width: 400px;
       }
       .form-right-container {
         width: 400px;
       }
    }
    .currency-width {
      margin-right: 10px;
      width: 90px;
    }
  .upload-box{
    margin-top: 10px;
  }
}
</style>
